// extracted by mini-css-extract-plugin
module.exports = {"InfoScreenWrapper":"_1yW9J9nUYl3641AyjMiDgU"};